import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  videoId: string;
}

const renderVideo = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/clipdeck/render', payload);
  return res.data;
};

export const useRenderVideo = () => {
  return useMutation(renderVideo, { onSuccess: (data) => data });
};
